import { InternshipModel } from "common/models/page-models/internship/internship/internship-data-model";
import { FormDataService } from "../Intership-List/intership-filter-form-data.service";
import { SmApiService } from "common/services/core-services/sm-api.service";
import { SystemService } from "common/services/core-services/system.service";
import { API_METHODS, API_URL } from "common/constants/sm-constants";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import moment from "moment";




@Injectable({
    providedIn: 'root'
})
export class InternshipFormDataService extends FormDataService<InternshipModel> {
    router: any;


    constructor(http: SmApiService, protected override ss: SystemService) {
        super(API_URL.internshipList, http, ss);
        // console.log('Internship Service')
    }


    createInstance(): InternshipModel {
        return new InternshipModel();
    }


    override getEditUrlAndMethod() {
        const edit = {
            url: environment.apiUrl + API_URL.internshipList,
            method: API_METHODS.post
        }
        return edit;
    }

    override modifyMultiModel(data) {
        // console.log(data, 'Data')
        const pageData = new InternshipModel()
        console.log(data[1].details)
        pageData.studentsList = data[1].details.map((student) => {
            return {
                name: student.name,
                invite: student.isInvited === 1 ? 'Sent' : 'Not Sent',
                not_invited: student.isNotInvited === 1 ? 'Not Sent' : 'Sent',
                reInvite: student.isReinvited === 1 ? 'Sent' : 'Not Sent',
                available_assigned: student.available_assigned === 1 ? 'Assigned' : 'Not Assigned',
                available_not_assigned: student.available_not_assigned === 1 ? 'Available' : 'Not Available',
                not_available: student.not_available === 1 ? 'Not Available' : 'Available',
                available: student.isStudentAvailable === 1 ? 'Yes' : 'No',
                invited_not_responded: student.invited_not_responded === 1 ? 'Responded' : 'Not Responeded',
                assigned: student.isInternshipAssigned === 1 ? 'Assigned' : 'Not Assigned',
                startDate: student.studentExpectedInternshipStartDate
                    ? moment(new Date(student.studentExpectedInternshipStartDate)).format('DD-MM-YYYY')
                    : '-',
                endDate: student.studentExpectedInternshipEndDate
                    ? moment(new Date(student.studentExpectedInternshipEndDate)).format('DD-MM-YYYY')
                    : '-',
                company: student.externalCompanyName || '',
                companyLocation: student.externalCompanyLocation || '',
                certificate: 'Yes',
                email: student.email,
                mobile: student.mobile_number,
                branch: student.branchName,
                college: student.name_of_college,
                region: student.region,
                state: student.StateName,
                id: student.id,
                internshipMasterIds: student.id,
                batch: student.batch_number,
                studentId: student.studentId,
                gender: student.gender,
                firstSem: student.first_year_score,
                secondSem: student.first_year2_score,
                thirdSem: student.second_year_score,
                fourthSem: student.second_year2_score,
                fifthSem: student.third_year_score,
                sixthSem: student.third_year2_score,
                seventhSem: student.fourth_year_score,
                eightSem: student.fourth_year2_score,
                nineSem: student.fifth_year_score,
                tenSem: student.fifth_year2_score,


            }
        })
        pageData.internshipList = data[0].details.map((internship) => {
            return {
                internshipTitle: internship.internshipTitle || '',
                companyName: internship.company_name || '',
                location: internship.company_location || '',
                startDate: internship.internshipStartDate
                    ? moment(new Date(internship.internshipStartDate)).format('YYYY-MM-DD')
                    : '-',
                endDate: internship.internshipEndDate
                    ? moment(new Date(internship.internshipEndDate)).format('YYYY-MM-DD')
                    : '-',
                mentorName: internship.company_mentor_name || '',
                studentCount: internship.student_count,
                id: internship.id,
                internshipMasterIds: internship.id,
                internshipCode: internship.internshipCode
            }
        })


        const Data = {
            "totalStudent": "",
            "totalInvitedStudent": "",
            "totalNotInvitedStudent": "",
            "totalInvitedButNotRespondedStudent": "",
            "totalNotAvailableStudent": "",
            "totalAvailableButNotAssignedStudent": "",
            "totalAvailableAndAssignedStudent": "",
            "totalCompletedStudent": "",
            "totalNotCompletedStudent": "",
            "totalJoinedStudent": "",
            "totalNotJoinedStudent": "",
            "totalInternship": "",
            "totalContinuedStudent": "",
            "totalDiscontinuedStudent": ""
        }

        const chartData = data[2].details

        pageData.internshipStats.totalInternships = chartData?.totalInternship || 0
        pageData.internshipStats.assignedStudents = chartData?.totalAvailableAndAssignedStudent || 0
        pageData.internshipStats.joinedStudents = chartData?.totalJoinedStudent || 0
        pageData.internshipStats.notJoined = chartData?.totalNotJoinedStudent || 0
        pageData.internshipStats.completed = chartData?.totalCompletedStudent || 0
        pageData.internshipStats.discontinued = chartData?.totalDiscontinuedStudent || 0

        pageData.invitationCounts = {
            invited: Number(chartData?.totalInvitedStudent) || 0,
            notInvited: Number(chartData?.totalNotInvitedStudent) || 0,
            total: (Number(chartData?.totalInvitedStudent) || 0) + (Number(chartData?.totalNotInvitedStudent) || 0)
        };

        pageData.availabilityCounts = {
            available: Number(chartData?.totalAvailbleStudent) || 0,
            notAvailable: Number(chartData?.totalNotAvailableStudent) || 0,
            notResponded: Number(chartData?.totalInvitedButNotRespondedStudent) || 0,
            total: (Number(chartData?.totalAvailbleStudent) || 0) +
                (Number(chartData?.totalNotAvailableStudent) || 0) +
                (Number(chartData?.totalInvitedButNotRespondedStudent) || 0)
        };

        pageData.assignedCounts = {
            assigned: Number(chartData?.totalAvailableAndAssignedStudent) || 0,
            notAssigned: Number(chartData?.totalAvailableButNotAssignedStudent) || 0,
            total: (Number(chartData?.totalAvailableAndAssignedStudent) || 0) +
                (Number(chartData?.totalAvailableButNotAssignedStudent) || 0)
        };

        pageData.completionCounts = {
            completed: Number(chartData?.totalCompletedStudent) || 0,
            discontinued: Number(chartData?.totalDiscontinuedStudent) || 0,
            notJoined: Number(chartData?.totalNotJoinedStudent) || 0,
            total: (Number(chartData?.totalAvailableAndAssignedStudent) || 0) + 0
        };

        // ----------Internship Charts------//

        pageData.internassignedCounts = {
            joined: Number(chartData?.totalJoinedStudent) || 0,
            notJoined: Number(chartData?.totalNotJoinedStudent) || 0,
            total: (Number(chartData?.totalAvailableAndAssignedStudent) || 0) + 0
        };

        pageData.joinedCounts = {
            continued: Number(chartData?.totalContinuedStudent) || 0,
            disContinued: Number(chartData?.totalDiscontinuedStudent) || 0,
            total: (Number(chartData?.totalJoinedStudent) || 0) + (Number(chartData?.totalDiscontinuedStudent)|| 0),
        };

        pageData.interncontinueCounts = {
            completed: Number(chartData?.totalCompletedStudent) || 0,
            disContinued: Number(chartData?.totalDiscontinuedStudent) || 0,
            notJoined: Number(chartData?.totalNotJoinedStudent) || 0,
            total: (Number(chartData?.totalCompletedStudent) || 0) +
                (Number(chartData?.totalDiscontinuedStudent) || 0) +
                (Number(chartData?.totalNotJoinedStudent) || 0)
        };

        pageData.interncompletionCounts = {
            completed: Number(chartData?.totalCompletedStudent) || 0,
            notCompleted: Number(chartData?.totalNotCompletedStudent) || 0,
            total: (Number(chartData?.totalCompletedStudent) || 0) + (Number(chartData?.totalNotCompletedStudent) || 0)
        };
        pageData.apiResData = data;
        return pageData;
    }
}